import axiosInstance from "./AxiosConfig";
import endpoints from "./endpoints";

export const referralService = {
  getReferralDashboard: (userId) => 
    axiosInstance.get(`${endpoints.tokenEndPoints.getReferralDashboard}/${userId}`),
  getReferralsMilestone: (userId) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.getReferralsMilestone}/${userId}`),
  getReferralsListing: (userId, page, limit, status) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.getReferralsListing}/${userId}?page=${page}&limit=${limit}&status=${status}`),
};